import { render, staticRenderFns } from "./ContractProposalPdf.vue?vue&type=template&id=1b4f28a1&scoped=true"
import script from "./ContractProposalPdf.vue?vue&type=script&lang=js"
export * from "./ContractProposalPdf.vue?vue&type=script&lang=js"
import style0 from "./ContractProposalPdf.vue?vue&type=style&index=0&id=1b4f28a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f28a1",
  null
  
)

export default component.exports